
import { Component, Vue } from 'vue-property-decorator'
import { getUserLocationInfo } from '@/utils/h5ToApp'

export interface AddressInfo {
  address: string // 地址
  longitude: number // 经度
  latitude: number // 纬度
  receiveAddressDtl: string // 精确地址
  jrAddress: string // 精确地址
}

@Component({
  name: 'AddressMapPage'
})
export default class AddressMapPage extends Vue {
  isIframeLoaded = false
  isReady = false // 控制 iframe 是否可以渲染
  iframeSrc = ''

  async getAddressInfo() {
    const queryLongitude = this.$route.query.longitude as string == '0' ? '' : this.$route.query.longitude
    const queryLatitude = this.$route.query.latitude as string == '0' ? '' : this.$route.query.latitude
    try {
      // 创建超时 Promise
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('timeout')), 5000)
      })
      
      // getUserLocationInfo 和 5秒超时
      const res: any = await Promise.race([
        getUserLocationInfo(),
        timeoutPromise
      ])
      const { longitude, latitude } = res
      const curCoor = `curLatitude=${latitude}&curLongitude=${longitude}`
      if (queryLongitude && queryLatitude) {
        this.iframeSrc = `${process.env.VUE_APP_BASE_WX}?latitude=${queryLatitude}&longitude=${queryLongitude}&${curCoor}`
      } else {
        this.iframeSrc = `${process.env.VUE_APP_BASE_WX}?latitude=${latitude}&longitude=${longitude}&${curCoor}`
      }
      console.log("iframeSrc", this.iframeSrc)
      this.isReady = true
    } catch (err: any) {
      if (err.message === 'timeout') {
        this.$toast.fail('获取用户经纬度超时，使用默认位置')
        this.iframeSrc = `${process.env.VUE_APP_BASE_WX}`
      } else {
        this.$toast.fail('获取用户经纬度失败')
      }

      console.log("iframeSrc", this.iframeSrc)
      this.isReady = true
    }
  }

  created() {
    // 监听来自 iframe 的消息
    window.addEventListener('message', this.handleMessage)
    this.getAddressInfo()
  }

  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  }

  // iframe 加载完成
  onIframeLoad() {
    this.isIframeLoaded = true
  }

  // 处理来自 iframe 的消息
  handleMessage(event: any) {
    // 如果 iframe 未加载，不处理消息
    if (!this.isIframeLoaded) {
      return
    }

    // 验证消息来源
    if (process.env.NODE_ENV == 'development' && event.origin == window.location.origin) {
      return
    }

    // 处理返回按钮
    if (event.data.data && event.data.data.name == "navigateBack") {
      this.routerBack()
      return
    }

    try {
      console.log(
        '----------',
        JSON.parse(event.data.data.arg.address),
        JSON.parse(event.data.data.arg.addressComponents)
      )
      const address = JSON.parse(event.data.data.arg.address)
      const addressComponents = JSON.parse(event.data.data.arg.addressComponents)

      // 判断是否是地址选择的消息
      if (address && addressComponents) {
        const addressInfo: AddressInfo = {
          address: address.title,
          receiveAddressDtl: address.address,
          jrAddress: addressComponents.province + addressComponents.city + addressComponents.district,
          longitude: address.point.lng,
          latitude: address.point.lat
        }

        window.sessionStorage.setItem('editStoreAddressInfo', JSON.stringify(addressInfo))
      }
    } catch (error) {
      console.error('处理 iframe 消息失败:', error)
      this.routerBack()
    }
  }

  // 路由返回
  routerBack() {
    if (this.$router) {
      this.$router.back()
    }
  }

}
